
export default function InfoCard({ info }: any) {
    return (
        <div className="infoCard h-100">
            <div className="content">{info && info}</div>
        </div>
    )
}
